import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface InputPropsInterface {
  size?: 'small' | 'medium' | 'large';
}

const DynamicLoader = ({ size }: InputPropsInterface) => {
  const { t } = useTranslation();
  switch (size) {
    case 'small':
      return <Image src="/pickspace-loader.gif" width="20" height="20" loading="lazy" alt={t('common.loading')} />;
    case 'medium':
      return <Image src="/pickspace-loader.gif" width="50" height="50" loading="lazy" alt={t('common.loading')} />;
    case 'large':
      return <Image src="/pickspace-loader.gif" width="100" height="100" loading="lazy" alt={t('common.loading')} />;
    default:
      return <Image src="/pickspace-loader.gif" width="50" height="50" loading="lazy" alt={t('common.loading')} />;
  }
};

export default DynamicLoader;
